import { render, staticRenderFns } from "./SettingIntegrationList.vue?vue&type=template&id=c0954b70&"
import script from "./SettingIntegrationList.vue?vue&type=script&lang=js&"
export * from "./SettingIntegrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports